import { BindUI } from '@tableau/react-mvvm';
import { Location } from '../../commonInfra/utils/Location';
import { ContentType, DraftDataItem, OmniBoxItemType } from "../models/Types";
import { OmniboxConfigurationService } from "../OmniboxConfigurationService";
import { SearchService } from "../services/SearchService";
import { IKeyboardNavigableItem, QuickSearchModule } from "./QuickSearchModule";
import { ContentDefinitions } from "../models/ContentDefinitions";
import { getSessionManagementServiceInstance, SessionManagementService } from "../services/SessionManagementService";
import { Messages } from "../../../gen-src/Localize";
import { searchTelemetry } from "../components/SearchTelemetry";

export const ImpressionType = 'jumpBackIn';

export interface JumpBackInItem extends IKeyboardNavigableItem {
    hiddenOwner: boolean;
    id: string;
    title: string;
    owner: string;
    url: string;
    icon: (props: any) => React.ReactSVGElement;
    data: DraftDataItem;
}

export class JumpBackInViewModel extends QuickSearchModule {
    @BindUI(QuickSearchModule.buildKeyboardNavigationPath) public jumpBackInItems: JumpBackInItem[];
    @BindUI() public currentKeyboardNavigableItem?: IKeyboardNavigableItem;
    @BindUI() public enabled = false;

    public onMount() {
        super.onMount();
        searchTelemetry.sendSearchImpressionEvent('', ImpressionType);
    }

    public initialize(): void {
        if (OmniboxConfigurationService.instance.configuration.jumpBackInMaxCount
            && SessionManagementService.instance.isOnlineEnvironmentChannel()) {
            this.enabled = true;
            SearchService.instance.getDrafts().then(drafts => {
                const hiddenOwner = getSessionManagementServiceInstance().isLimitedUserVisibilityChannel();

                this.jumpBackInItems = drafts.slice(0, OmniboxConfigurationService.instance.configuration.jumpBackInMaxCount || 0).map((draft, index) => {
                    return {
                        ownerModule: this,
                        getIdentifier: () => 'JumpBackIn' + index.toString(),
                        data: draft,
                        id: draft.luid,
                        url: draft.url,
                        icon: ContentDefinitions[ContentType.workbook].icon,
                        title: draft.title,
                        hiddenOwner: hiddenOwner,
                        owner: hiddenOwner ? Messages.hiddenUser() : draft.ownerName
                    };
                });
            });
        }
    }

    public getFirstKeyboardNavigableItem(): IKeyboardNavigableItem {
        return this.jumpBackInItems[0];
    }

    public getLastKeyboardNavigableItem(): IKeyboardNavigableItem {
        return this.jumpBackInItems[this.jumpBackInItems.length - 1];
    }

    public isKeyboardNavigable(): boolean {
        return !this.isUnmounted && this.jumpBackInItems && this.jumpBackInItems.length > 0;
    }

    public buildKeyboardNavigationPathInOwnModule(): void {
        if (this.isKeyboardNavigable()) {
            this.getFirstKeyboardNavigableItem().up = this.previousKeyboardNavigableModule.getLastKeyboardNavigableItem();

            for (let i = 0; i < this.jumpBackInItems.length - 1; i++) {
                const currentItem = this.jumpBackInItems[i];
                const nextItem = this.jumpBackInItems[i + 1];
                this.linkTwoKeyboardNavigableItems(currentItem, nextItem, true);
            }

            this.getLastKeyboardNavigableItem().down = this.nextKeyboardNavigableModule.getFirstKeyboardNavigableItem();
        }
    }
    public selectItemByKeyboard(): void {
        const currentItem = this.currentKeyboardNavigableItem as JumpBackInItem;
        this.onItemClicked(currentItem, this.jumpBackInItems.indexOf(currentItem));
    }

    public onItemClicked(item: JumpBackInItem, index: number) {
        this.omniboxViewModel.onResultItemSelected(OmniBoxItemType.jumpBackInItem, this.jumpBackInItems.length, index, item.id.toString());

        if (!OmniboxConfigurationService.instance.configuration.onJumpBackInSectionItemClick) {
            Location.instance.setUrl(item.url);
        } else {
            OmniboxConfigurationService.instance.configuration.onJumpBackInSectionItemClick(ContentType.workbook, item.data);
        }
    }
}